module.exports = __webpack_public_path__ + "static/img/top.d218328.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/top.png
// module id = C3m4
// module chunks = 52